import { render, staticRenderFns } from "./authGroupMaintain.vue?vue&type=template&id=c2cef776&scoped=true&lang=pug"
import script from "./authGroupMaintain.vue?vue&type=script&lang=js"
export * from "./authGroupMaintain.vue?vue&type=script&lang=js"
import style0 from "./authGroupMaintain.vue?vue&type=style&index=0&id=c2cef776&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cef776",
  null
  
)

export default component.exports